import { render } from "./BaseRadio.vue?vue&type=template&id=5fdc1096&scoped=true"
import script from "./BaseRadio.vue?vue&type=script&lang=js"
export * from "./BaseRadio.vue?vue&type=script&lang=js"

import "./BaseRadio.vue?vue&type=style&index=0&id=5fdc1096&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5fdc1096"

export default script